import React from 'react';
import { FederationMembersPage } from '../../components/FederationMembersPage';
const members = [{
  name: 'Олівсон Олександр',
  role: 'Голова комісії зі скі-альпінізму та скайранінгу',
  email: 'olivson63@gmail.com'
}, {
  name: 'Чухран Михайло',
  role: 'Член комісії зі скі-альпінізму та скайранінгу',
  email: 'chukhran@gmail.com'
}];
export function SkiAlpinismCommission() {
  return <FederationMembersPage title="Комісія зі Скі-альпінізму та Скайранінгу" subtitle="Комісія зі скі-альпінізму та скайранінгу комітету альпінізму ФАіСУ" members={members} data-id="element-425" />;
}